
var componentMap = {

}
self.componentMap = componentMap

export default componentMap
